module.exports = __webpack_public_path__ + "img/15.8169220a.png";